import { Component, OnInit, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { G_BrandsViewModel } from 'src/app/viewmodels/g-item/G_BrandsViewModel';
import { G_ModelsViewModel } from 'src/app/viewmodels/g-settings/G_ModelsViewModel';
//import { AccountDefinigDtlView } from 'src/app/viewmodels/';
//import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { GItemQRViewModel } from 'src/app/viewmodels/g-item/GItemQRViewModel';
import { GItemModelViewModel } from 'src/app/viewmodels/g-item/GItemModelViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { GItemSupplierViewModel } from 'src/app/viewmodels/g-item/GItemSupplierViewModel';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { GBrandModel, GItemModelModel, GItemQRModel, GItemSupplierModel, GModelsModel, SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { AppConsts } from 'src/app/common/app-consts';

@Component({
  selector: 'app-item-form',
  templateUrl: './item-form.component.html',
  styleUrls: ['./item-form.component.scss']
})
export class ItemFormComponent implements OnInit {
  @Input() public vm: SaveItemRequest;
  @Input() public forItemType: '';
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() public vmChange = new EventEmitter<SaveItemRequest>();
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  modalRef: BsModalRef;
  modalRefLv2: BsModalRef;

  public ctagtype = 'tagtype';
  public tagTypes: any = [];

  public cssCategory = 'sscategory';
  public ssCategories: any = [];

  public ccolors = 'colors';
  public colors: any = [];

  public cunit = 'unit';
  public unit: any = [];


  public citemtype = 'itemtype';
  public itemTypes: any = [];

  public cmanufecturers = 'manufecturers';
  public manufecturers: any = [];

  public csuppliers = 'suppliers';

  public cbrands: any = 'brands';
  public brands: any = [];
  public selectedBrands: any = [];

  public cmodels = 'models';
  public models: any = [];
  public modelsList: any = [];
  public selectedModels: any = [];

  public suppliers: any = [];
  public selectedSuppliers: any = [];

  public dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'accTitle',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    showSelectedItemsAtTop: true,
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public brandsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    showSelectedItemsAtTop: true,
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public modelsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    showSelectedItemsAtTop: true,
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  name = 'GenericModel';
  id = 'id';
  checked = false;
  disabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';

  public newCode: string = "-1";
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getSuppliers();
    this.getItemTypes();
    this.getManufecturers();
    this.getSsCategories();
    this.getcolors();
    this.getunits();
    this.getBrands();
    this.getModels();
    debugger
    this.vm.isGeneric = false;
    if (this.vm.isGenericModel)
      this.vm.isGeneric = true;
    if (this.vm == undefined) {
      this.vm = new SaveItemRequest();
      this.vm.gItemQRCode = [];
      this.vm.itemType = new ItemViewModel1(0, '');
      this.vm.isGeneric = false;
    }
    else {
      let slectedSuplierList: any = [];
      let slecbrandlist: any = [];
      let slectedModellist: any = [];

      if (this.vm.gItemSupplier != undefined && this.vm.gItemSupplier.length > 0) {
        setTimeout(() => {
          this.vm.gItemSupplier.forEach(x => {
            console.log(this.suppliers.length);
            let selectedSupliers = this.suppliers.find(y => y.id == x.supplier.id);

            if (selectedSupliers != undefined && selectedSupliers != null) {

              slectedSuplierList.push(selectedSupliers);
            }
          })
          this.selectedSuppliers = slectedSuplierList;
        }, 2000);

      }

      if (this.vm.gItemModels != undefined && this.vm.gItemModels.length > 0) {
        this.vm.gItemModels.forEach(x => {
          let sM = new GModelsModel();
          sM.id = x.model.id;
          sM.brand = new ItemViewModel1(x.brand.id, x.brand.name);
          sM.name = x.model.name,
            slectedModellist.push(sM);
          let brandalready = slecbrandlist.find(y => y.id == x.brand.id);
          if (brandalready == null || brandalready == undefined) {
            let sB = new GBrandModel();
            sB.id = x.brand.id;
            sB.name = x.brand.name;
            slecbrandlist.push(sB);
          }
        })
        this.selectedModels = slectedModellist;
        this.selectedBrands = slecbrandlist;
        this.getModelsForBrands(null);
      }
    }
    if (this.vm.code == undefined) {
      this._uow.gSettingService.LoadItemFormAsync(this.newCode).subscribe((res: any) => {
        debugger
        this._uow.logger.log(res);
        this.vm.code = res.code;
      }, (err) => this._uow.logger.log(err));
    }

    this.vmChange.emit(this.vm);
    this._uow.logger.log(this.vm);

    if (this.modal_title == undefined) {
      this.modal_title = 'Item';
    }

  }

  public isValid = true;
  public validateInput() {
    this.newCode = this.vm.code;
    this._uow.gSettingService.LoadItemFormAsync(this.newCode).subscribe((res: any) => {
      debugger
      const regex = /^[a-zA-Z0-9 ]*$/;
      if (!regex.test(this.vm.code) || res.status) {
        debugger
        this.isValid = true;
      } else {
        this.isValid = false;
      }

    }, (err) => this._uow.logger.log(err));
  }
  getSuppliers() {
    this._uow.gSettingService.GetGCustomersDropDownAsync(AppConsts.SUPPLIER).subscribe((res: any) => {
      this.suppliers = res.result;
      this._uow.logger.log(this.suppliers);
    }, (err) => this._uow.logger.log(err));
  }

  getItemTypes() {
    this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => {
      this.itemTypes = res.result;
    }, (err) => this._uow.logger.log(err));
  }
  getManufecturers() {
    this._uow.gSettingService.GetManufacturersAsync().subscribe((res: any) => {
      this.manufecturers = res.result;
    }, (err) => this._uow.logger.log(err));
  }

  getBrands() {
    this._uow.gSettingService.GetGBrandsAsync().subscribe((res: any) => {
      this.brands = res.result;
    }, (err) => this._uow.logger.log(err));
  }

  getSsCategories() {
    this._uow.gSettingService.GetSSCategoriesAsync().subscribe((res: any) => {
      this.ssCategories = res.result;
    }, (err) => this._uow.logger.log(err));
  }
  getcolors() {
    this._uow.gSettingService.GetColoursAsync().subscribe((res: any) => {
      this.colors = res.result;
    }, (err) => this._uow.logger.log(err));
  }
  getunits() {
    this._uow.gSettingService.GetUnitsAsync().subscribe((res: any) => {
      this.unit = res.result;
    }, (err) => this._uow.logger.log(err));
  }

  getModels() {
    this._uow.gSettingService.GetVehicleModelsAsync().subscribe((res: any) => {
      this.modelsList = res.result;
      this.getModelsForBrands(null);
    }, (err) => this._uow.logger.log(err));
  }



  // get modesl
  getModelsForBrands(e) {
    debugger
    var ids = [];
    this.selectedBrands.forEach(b => {
      ids.push(b.id);
    });
    const selectedIds = this.selectedBrands.map(b => b.id);
    this.models = this.modelsList.filter(m => selectedIds.includes(m.brand.id));
  }



  onChange(e) {
    // debugger
    console.log(e)
    if (e) {
      this.vm.isGeneric = true;
    }
    if (!e) {
      this.vm.isGeneric = false;
    }
    console.log(this.vm.isGeneric);
  }

  saveOrUpdate() {
    debugger
    // this._jq.showSpinner(true);
    this.spinner.show();
    this._uow.logger.log(this.vm);
    this.vm.gItemModels = [];
    this.vm.gItemSupplier = [];
    //this.vm.gItemQRCode = [];

    if (this.vm.isGeneric == false)
      if (this.selectedModels !== undefined && this.selectedModels.length > 0) {
        this.selectedModels.forEach(m => {
          let model = this.models.find(x => x.id == m.id);
          this._uow.logger.log(model);
          if (model !== undefined) {
            let mi = new GItemModelModel();
            mi.id = model.id;
            mi.brand = new ItemViewModel1(model.brand.id, model.brand.name);
            mi.model = new ItemViewModel1(model.id, model.name);
            this.vm.gItemModels.push(mi);
          }
        });
      }
    if (this.selectedSuppliers !== undefined && this.selectedSuppliers.length > 0) {
      this.selectedSuppliers.forEach(s => {
        let model = this.suppliers.find(x => x.id == s.id);
        this._uow.logger.log(model);
        if (model !== undefined) {
          let si = new GItemSupplierModel();
          si.id = model.id;
          si.supplier = new ItemViewModel1(model.id, model.name);
          this.vm.gItemSupplier.push(si);
        }
      });
    }
    this._uow.gSettingService
      .SaveItemAsync(this.vm)
      .toPromise().then((res: any) => {
        this._jq.showSpinner(true);
        this._uow.logger.log(res);
        this.submitted = true;
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        );

        this.bsmRef.hide();
        this.onSubmitted.emit(this.submitted);
      })
      .catch((error) => {
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        this._uow.logger.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
      });
  }

  checkItemDublication(tagName) {
    debugger
    this._jq.showSpinner(true);
    this._uow.itemService.checkDublication(tagName).toPromise().then((res: any) => {
      if (res === true) {
        this.IsDublicate = false;
      } else {
        this.IsDublicate = true;
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }

  onItemDSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.ngOnInit();
    }
  }

  // exteral coponents
  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
  }
  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }
  openTagTypeModel(template: TemplateRef<any>) {
    this.openModal(template);
  }

  getTagTypes() {
    this._uow.tagsTypeService.GetList().subscribe((res: any) => {
      this.tagTypes = res;
    }, (err) => this._uow.logger.log(err));
  }





  // selects
  onBrandSelect(e) {
    this.getModelsForBrands(null);
  }
  onBrandDeSelected(e) {
    this.getModelsForBrands(null);
  }
  onModelSelected(e) {
    this._uow.logger.log(e.Id);
    // let model = this.models.find(x => x.Id == e.Id);
    // if (model !== undefined) {
    //   this.vm.GItemModels.push(model);
    // }
  }
  onModelDeSelected(e) {
    this.selectedModels.splice(this.selectedModels.indexOf(e), 1);
    // let model = this.models.find(x => x.Id == e.Id);
    // if (model !== undefined) {
    //   this.vm.GItemModels.splice(this.vm.GItemModels.indexOf(model), 1);
    // }
  }
  onSupplierSelect(e) {
    this._uow.logger.log(e);
  }
  onSupplierDeSelect(e) {
    this._uow.logger.log(e);
  }

  // qr
  onGenerateQrCode() {
    this.getQrCode();
  }
  onRemoveQrCode(obj) {
    this._uow.logger.log(obj)
    let item = this.vm.gItemQRCode.find(x => x.code == obj.code);
    if (item !== undefined) {
      this.vm.gItemQRCode.splice(this.vm.gItemQRCode.indexOf(item), 1);
    }
  }

  getQrCode() {
    if (this.vm.gItemQRCode == undefined || this.vm.gItemQRCode.length == 0) {
      this.vm.gItemQRCode = [];
    }
    this._uow.gSettingService.LoadItemFormAsync('-1').subscribe((res: any) => {
      debugger
      let item = new GItemQRModel();
      item.code = `${this.vm.code}${res.code}`;
      this.vm.gItemQRCode.push(item);
    }, (err) => this._uow.logger.log(err));
  }

  // extrnal components
  onItemSubmitted(e, mf) {
    this._uow.logger.log(e);
    if (e === true) {
      if (mf == this.ctagtype) {
        this.getTagTypes();
      }
      if (mf == this.citemtype) {
        this.getItemTypes();
      }
      if (mf == this.cmanufecturers) {
        this.getManufecturers();
      }
      if (mf == this.csuppliers) {
        this.getSuppliers();
      }
      if (mf == this.cbrands) {
        this.getBrands();
      }
      if (mf == this.cmodels) {
        this.getModelsForBrands(e);
      }
      if (mf == this.ccolors) {
        this.getcolors();
      }
      if (mf == this.cunit) {
        this.getunits();
      }
    }
  }

   closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
  ////////////warehouse wise list////////////////
  // getwareHouseItemList(id) {
  //   // this._jq.showSpinner(true);
  //   // this.spinner.show();
  //   debugger;
  //   this._uow.wareHouseItemService.GetListItem(id).subscribe((res: Array<any>) => {
  //     // this._jq.reinitDataTable(res);
  //     res.forEach(element =>{
  //       element.FK_WareHouse_Id = new ItemViewModel(this.FK_WareHouse_Id.Id,this.FK_WareHouse_Id.Name);
  //     });
  //     this.warehouseItemVmlist = res;
  //     console.log('list item',res);
  //     // this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     // this.spinner.hide();
  //   });
  // }
}
